import { ReactElement } from 'react';

interface ShadedPatternProps {
  color: string;
  backgroundColor?: string;
  id?: string;
  visibleTag?: boolean;
  invert?: boolean;
}

const ShadedPattern = ({
  color,
  backgroundColor = 'transparent',
  id = color,
  visibleTag = true,
  invert = false
}: ShadedPatternProps): ReactElement => (
  <svg xmlns='http://www.w3.org/2000/svg'>
    <defs>
      <pattern id={`shadedStripe${id}`} width='10' height='10' patternUnits='userSpaceOnUse'>
        <rect width='10' height='10' fill={invert ? color : backgroundColor} />
        <rect width='2' height='2' x='0' y='8' fill={invert ? backgroundColor : color} />
        <rect width='2' height='2' x='2' y='6' fill={invert ? backgroundColor : color} />
        <rect width='2' height='2' x='4' y='4' fill={invert ? backgroundColor : color} />
        <rect width='2' height='2' x='6' y='2' fill={invert ? backgroundColor : color} />
        <rect width='2' height='2' x='8' y='0' fill={invert ? backgroundColor : color} />
      </pattern>
    </defs>
    {visibleTag && <rect width='100%' height='100%' fill={`url(#shadedStripe${id})`} />}
  </svg>
);

export { ShadedPattern };
